export function CompleteStepController($scope, orderInfoService, cartService,
    cartDisplayService, restaurantInfoFactory, AuthenticationService, googleAnalyticsTrackingService,
    loyaltyService, loginModalService) {
    'ngInject';
    $scope.savedCustomer = orderInfoService.getCustomer();
    $scope.savedDeliveryInfo = orderInfoService.getDeliveryInfo();
    $scope.savedPayment = orderInfoService.getPayment();
    $scope.cart = cartService.getPreviousCart();
    $scope.cartDisplay = cartDisplayService.displayData;
    $scope.previousCart = true;
    $scope.missingCart = true;
    $scope.accountCreated = false;
    $scope.getPrependFormMessage = getPrependFormMessage;
    $scope.loginModalService = loginModalService;
    $scope.loyaltyAccountAttached = loyaltyService.isLoyaltyAccountAttached($scope.cart);
    $scope.loyaltySignupAllowed = false;
    $scope.createAccountSuccessCallback = () => googleAnalyticsTrackingService.trackCreateAccountSuccess();
    $scope.createAccountErrorCallback = errorMessage => googleAnalyticsTrackingService.trackCreateAccountError(errorMessage);
    $scope.termsOfServiceCallback = () => googleAnalyticsTrackingService.trackTermsOfService();
    $scope.privacyPolicyCallback = () => googleAnalyticsTrackingService.trackPrivacyPolicy();
    $scope.paymentString = getPaymentString();

    activate();

    ///-----------------------------------------------

    function getPaymentString() {
        let savedPayment = $scope.savedPayment;
        if(savedPayment.method === 'CREDIT') {
            const startString = 'Credit Card (';
            const endString = ')';
            if(savedPayment.guid) return `${startString}${savedPayment.maskedPan}${endString}`;
            return `${startString}XXXX-${savedPayment.cardNumber.substr(-4)}${endString}`;
        }
        return 'Cash';
    }

    function getPrependFormMessage() {
        return 'Enter a password to save payment, address, and order info for easy re-ordering on your next visit!';
    }

    function activate() {
        getPaymentString();
        orderInfoService.getOrderData()
            .then(({
                orderGuid,
                openedDate
            }) => {
                $scope.savedOrderData = {
                    orderGuid,
                    openedDate
                };
            });
        loyaltyService.getConfig().then(config => {
            $scope.loyaltySignupAllowed = config.signupAllowed;
        });
        restaurantInfoFactory.getInfo(['general']).then(info => {
            $scope.restaurantName = info.general.name;
            $scope.restaurantGuid = info.general.guid;
        });

        cartDisplayService.getDisplayData($scope.previousCart).then(function() {
            $scope.cartDisplay = cartDisplayService.displayData;
            $scope.isDelivery = $scope.cartDisplay.diningOption === 'DELIVERY';
            $scope.missingCart = false;
        }).catch(function() {
            $scope.missingCart = true;
        });

        $scope.$on('$destroy', function() {
            orderInfoService.clearCCData();
            orderInfoService.clearOrderData();
        });

        $scope.isAuthenticated = AuthenticationService.isAuthenticated();
    }
}
